import React, {Component} from 'react';
import {Input, Label} from 'reactstrap';

class VariantSelector extends Component {
  render() {
    return (
      <div>
        <Label for={this.props.option.name}>{this.props.option.name}</Label>
        <Input
          type="select"
          className="Product__option"
          name={this.props.option.name}
          key={this.props.option.name}
          onChange={this.props.handleOptionChange}>
          {this.props.option.values.map(value => {
            return (
              <option
                value={value}
                key={`${this.props.option.name}-${
                  value.value
                }`}>{`${value}`}</option>
            );
          })}
        </Input>
      </div>
    );
  }
}

export default VariantSelector;



// WEBPACK FOOTER //
// ./src/components/VariantSelector.js